import { render, staticRenderFns } from "./AutosaveSnackbar.vue?vue&type=template&id=38502efe&"
import script from "./AutosaveSnackbar.vue?vue&type=script&lang=js&"
export * from "./AutosaveSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports